import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e1d54ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "authOptIn" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "OptInHeader" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Stay informed with emails"),
  /*#__PURE__*/_createElementVNode("div", { class: "DiagonalDivider" }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "OptInLetterbox",
    src: "https://monet-prtl-co.imgix.net/Shared/Registration/illustration_ support_email.svg",
    alt: "Subscribe to our e-mails"
  })
], -1 /* HOISTED */))
const _hoisted_3 = { class: "ContentContainer" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Receive inside information in your inbox", -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", { class: "OptInList" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Recommended programmes for you"),
  /*#__PURE__*/_createElementVNode("li", null, "Scholarship opportunities and partner offers"),
  /*#__PURE__*/_createElementVNode("li", null, "Student reviews"),
  /*#__PURE__*/_createElementVNode("li", null, "Latest news in higher education")
], -1 /* HOISTED */))
const _hoisted_6 = { class: "ActionContainer" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "lnr-cross" }, null, -1 /* HOISTED */))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "lnr-check" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PopUp = _resolveComponent("PopUp")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_PopUp, {
      identifier: "OptInPopUp",
      appIdentifier: _ctx.appIdentifier
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                "data-cy": "DeclineButton",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.notNow && _ctx.notNow(...args)))
              }, [
                _createTextVNode("No "),
                _hoisted_7
              ]),
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.accept && _ctx.accept(...args))),
                class: "DriverButton"
              }, [
                _createTextVNode("Yes, sign me up "),
                _hoisted_8
              ])
            ])
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["appIdentifier"])
  ]))
}